import {useState, useRef, useEffect, useCallback} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, CardText, Form, Label, Input, Button, Textarea } from 'reactstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import { MdOutlineAdd, MdRemove } from 'react-icons/md';
import { v4 as uuidv4 } from 'uuid';
import useAuth from '../../hooks/useAuth';


const AddCommunityFeature = () => {
  const { auth } = useAuth();

   // ** States
   let initialState = {
    featureName: '',
    featureDesc: ''
  };

  const [communityFeature, setCommunityFeature] = useState(initialState)

    const handleChange = (event) => {
        const { value, name } = event.target
        setCommunityFeature(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }

    const handleSaveClick = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('featureName', communityFeature.featureName);
        formData.append('featureDesc', communityFeature.featureDesc);
    
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community-features/save`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + auth.accessToken
                }
            })

            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            setCommunityFeature(initialState)

        } catch (error) {
            error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      setCommunityFeature(initialState)
    }


  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Add Community Feature</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
            <div className='mb-1'>
              <Label className='form-label' for='featureName'>
                Feature Name <span className='text-danger'>*</span>
              </Label>
              <Input
                id='featureName'
                type='email'
                className='me-1'
                name='featureName'
                required={true}
                value={communityFeature.featureName}
                onChange={handleChange}
                
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='featureDesc'>
                Feature Description <span className='text-danger'>*</span>
              </Label>
              <Input
                id='featureDesc'
                type='textarea'
                className='me-1'
                name='featureDesc'
                required={true}
                value={communityFeature.featureDesc}
                onChange={handleChange}
                
              />
            </div>
           
            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={handleSaveClick}
                >
                  Save
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
    
      <Row sm="12" className="mt-4 text-center">
          <Link to={"/community/feature/view"} className="go_back" >
            <BiLeftArrowAlt size={30} />  Go to communityFeature list
          </Link>
      </Row> 
    </div>
  );
};

export default AddCommunityFeature;
